import React, { useCallback, useRef } from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import DropdownUserRoles from "@client.components/DropdownUserRoles";
import UserRoles from "@client.enums/userRoles";
import AddUserButton from "./AddUserButton";
import usePermission from "@client.hooks/usePermission";

const TopBar = ({ getGridRef, onRoleFilterChange }) => {
  const { t } = useTranslation();
  const { isAllowed } = usePermission();

  const inputRef = useRef(null);
  const onFilterTextBoxChanged = useCallback(() => {
    getGridRef().current.api.setQuickFilter(inputRef.current.value);
  }, [getGridRef]);
  return (
    <div className="filter-search-bar">
      <div className="search">
        <span>{t("components.UsersDataTable.search")}:</span>
        <input
          ref={inputRef}
          type="text"
          placeholder={t("components.UsersDataTable.search.placeholder")}
          onInput={onFilterTextBoxChanged}
        />
      </div>
      <div className="filter">
        <span>{t("components.UsersDataTable.filters")}:</span>
        <DropdownUserRoles
          onSelect={onRoleFilterChange}
          defaultValue={UserRoles.All}
        />
      </div>
      {isAllowed() && <AddUserButton />}
    </div>
  );
};

TopBar.propTypes = {
  getGridRef: PropTypes.func,
  onRoleFilterChange: PropTypes.func,
};

export default TopBar;
